var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSardinia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0117C24.8366 32.0117 32 24.8483 32 16.0117C32 7.17516 24.8366 0.0117188 16 0.0117188C7.16344 0.0117188 0 7.17516 0 16.0117C0 24.8483 7.16344 32.0117 16 32.0117Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9248H18.0871H18.087V0.147156C17.4038 0.0582188 16.7073 0.0117188 16 0.0117188C15.2927 0.0117188 14.5962 0.0582188 13.9131 0.147156V13.9247V13.9247H0.135438C0.0465 14.6079 0 15.3044 0 16.0117C0 16.719 0.0465 17.4155 0.135438 18.0987H13.9129H13.913V31.8763C14.5962 31.9652 15.2927 32.0117 16 32.0117C16.7073 32.0117 17.4038 31.9653 18.0869 31.8763V18.0988V18.0987H31.8646C31.9535 17.4155 32 16.719 32 16.0117C32 15.3044 31.9535 14.6079 31.8646 13.9248Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6522 5.5769C22.3556 5.5769 21.2661 6.46372 20.9572 7.66384L23.6522 8.35947L26.3471 7.66384C26.0382 6.46378 24.9488 5.5769 23.6522 5.5769Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 11.8379L24.3478 12.5335V11.0546C25.3256 10.8028 26.0953 10.033 26.347 9.05524L23.6522 8.35962H20.174L20.8696 10.4466V11.8379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3471 7.66382H20.174V9.05513V10.4464H20.8696V9.05513H26.347C26.4042 8.83282 26.4348 8.59969 26.4348 8.35951C26.4348 8.11926 26.4044 7.88613 26.3471 7.66382Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04351 5.5769C7.74688 5.5769 6.65745 6.46372 6.34857 7.66384L9.04351 8.35947L11.7384 7.66384C11.4296 6.46378 10.3401 5.5769 9.04351 5.5769Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26087 11.8379L9.73912 12.5335V11.0546C10.7169 10.8028 11.4866 10.033 11.7382 9.05524L9.0435 8.35962H5.56519L6.26081 10.4466V11.8379H6.26087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7384 7.66382H5.56519V9.05513V10.4464H6.26081V9.05513H11.7382C11.7954 8.83282 11.8261 8.59969 11.8261 8.35951C11.8261 8.11926 11.7957 7.88613 11.7384 7.66382Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6522 19.49C22.3556 19.49 21.2661 20.3768 20.9572 21.5769L23.6522 22.2726L26.3471 21.5769C26.0382 20.3768 24.9488 19.49 23.6522 19.49Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8696 25.751L24.3478 26.4466V24.9676C25.3256 24.7159 26.0953 23.9461 26.347 22.9683L23.6522 22.2727H20.174L20.8696 24.3596V25.751Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3471 21.5769H20.174V22.9682V24.3595H20.8696V22.9682H26.347C26.4042 22.7459 26.4348 22.5128 26.4348 22.2726C26.4348 22.0324 26.4044 21.7993 26.3471 21.5769Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04351 19.49C7.74688 19.49 6.65745 20.3768 6.34857 21.5769L9.04351 22.2726L11.7384 21.5769C11.4296 20.3768 10.3401 19.49 9.04351 19.49Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26087 25.751L9.73912 26.4466V24.9676C10.7169 24.7159 11.4866 23.9461 11.7382 22.9683L9.0435 22.2727H5.56519L6.26081 24.3596V25.751H6.26087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7384 21.5769H5.56519V22.9682V24.3595H6.26081V22.9682H11.7382C11.7954 22.7459 11.8261 22.5128 11.8261 22.2726C11.8261 22.0324 11.7957 21.7993 11.7384 21.5769Z",
    fill: "#ACABB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSardinia);
export default __webpack_public_path__ + "static/media/flag_sardinia.82a1af665513a0ee942d3b74bcd9d02b.svg";
export { ForwardRef as ReactComponent };